import {EventBus} from "../events/EventBus";
import {Section} from "../services/Section";
import {ObfuscatedElementClickedEvent} from "../events/Events";
import PageData from "../PageData";

export default class ObfuscatedFields {
    private readonly pageData: PageData;

    private constructor(pageData: PageData) {
        this.pageData = pageData;
        this.addEventListeners();
    }

    static init(pageData: PageData) {
        new ObfuscatedFields(pageData);
    }

    addEventListeners() {
        // Email
        const obfuscatedContentEmailButtons: string[] = [];
        const eventBus: EventBus = EventBus.getInstance();
        Array.from<HTMLElement>(document.querySelectorAll('[id^="obfuscated_content_email"]')).forEach((button) => {
            const section: Section = Section.SECTION_ADPAGE_DESCRIPTION_INFO;
            button.addEventListener('click', () => {
                eventBus
                    .emit(new ObfuscatedElementClickedEvent({
                        section: section,
                        propertyAdId: this.pageData.id,
                        pageViewId: this.pageData.pageViewType,
                        step: 2,
                        htmlButtonClicked: button,
                        pageViewType: this.pageData.pageViewType,
                    }));
            });
            if (obfuscatedContentEmailButtons.includes(button.id)) return;
            obfuscatedContentEmailButtons.push(button.id);
        });
        // Url
        const obfuscatedContentURlButtons: string[] = [];
        Array.from<HTMLElement>(document.querySelectorAll('[id^="obfuscated_content_url"]')).forEach((button) => {
            const section: Section = Section.SECTION_ADPAGE_DESCRIPTION_INFO;
            button.addEventListener('click', () => {
                eventBus
                    .emit(new ObfuscatedElementClickedEvent({
                        section: section,
                        propertyAdId: this.pageData.id,
                        pageViewId: this.pageData.pageViewType,
                        step: 2,
                        htmlButtonClicked: button,
                        pageViewType: this.pageData.pageViewType,
                    }));
            });
            if (obfuscatedContentURlButtons.includes(button.id)) return;
            obfuscatedContentURlButtons.push(button.id);
        });
        // Phone
        const obfuscatedContentPhoneButtons: string[] = [];
        Array.from<HTMLElement>(document.querySelectorAll('[id^="obfuscated_content_phone"]')).forEach((button) => {
            const section: Section = Section.SECTION_ADPAGE_DESCRIPTION_VIEW_PHONE;
            button.addEventListener('click', () => {
                eventBus
                    .emit(new ObfuscatedElementClickedEvent({
                        section: section,
                        propertyAdId: this.pageData.id,
                        pageViewId: this.pageData.pageViewId,
                        step: 2,
                        htmlButtonClicked: button,
                        pageViewType: this.pageData.pageViewType,
                    }));
            });
            if (obfuscatedContentPhoneButtons.includes(button.id)) return;
            obfuscatedContentPhoneButtons.push(button.id);
        });
        // WhatsApp
        const obfuscatedContentWhatsAppButtons: string[] = [];
        Array.from<HTMLElement>(document.querySelectorAll('[id^="obfuscated_content_whatsapp"]')).forEach((button) => {
            const section: Section = Section.SECTION_ADPAGE_DESCRIPTION_WHATSAPP;
            button.addEventListener('click', () => {
                eventBus
                    .emit(new ObfuscatedElementClickedEvent({
                        section: section,
                        propertyAdId: this.pageData.id,
                        pageViewId: this.pageData.pageViewId,
                        step: 2,
                        htmlButtonClicked: button,
                        pageViewType: this.pageData.pageViewType,
                    }));
            });
            if (obfuscatedContentWhatsAppButtons.includes(button.id)) return;
            obfuscatedContentWhatsAppButtons.push(button.id);
        });
        // Line
        const obfuscatedContentLineButtons: string[] = [];
        Array.from<HTMLElement>(document.querySelectorAll('[id^="obfuscated_content_line"]')).forEach((button) => {
            const section: Section = Section.SECTION_ADPAGE_DESCRIPTION_LINE;
            button.addEventListener('click', () => {
                eventBus
                    .emit(new ObfuscatedElementClickedEvent({
                        section: section,
                        propertyAdId: this.pageData.id,
                        pageViewId: this.pageData.pageViewId,
                        step: 2,
                        htmlButtonClicked: button,
                        pageViewType: this.pageData.pageViewType,
                    }));
            });
            if (obfuscatedContentLineButtons.includes(button.id)) return;
            obfuscatedContentLineButtons.push(button.id);
        });
    }
};